export default __webpack_public_path__ + "static/media/sauced_vanilla_left.23b74e67.png";